<template>
  <v-select
    v-model="data"
    :options="options.results"
    @open="onOpen"
    @close="onClose"
    :label="label"
    :reduce="(data) => data.id"
    :getOptionLabel="getOptionLabel"
  >
    <template #list-footer>
      <li v-show="load" ref="load" class="loader">Loading more options...</li>
    </template>
  </v-select>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },
  props: {
    state: Object,
    options: Object,
    label: String,
    getOptionLabel: Function,
  },
  data() {
    return {
      count: null,
      data: null,
      observer: null,
      load: true,
      pagination: {
        page: 0,
        page_size: 15,
        count: 1,
      },
      target: null,
    };
  },
  watch: {
    data(newValue) {
      this.$emit("input", newValue);
    },
    state(newValue) {
      this.data = newValue;
    },
    async options(newValue) {
      if (!newValue.count) {
        return;
      }
      this.pagination.count = newValue.count;

      const { results, count } = newValue;
      if (count === results.length) {
        this.load = false;
      } else {
        this.load = true;
      }
      
      if (this.target && this.target.offsetParent) {
        const ul = this.target.offsetParent;
        const scrollTop = ul.scrollTop;
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
  },
  methods: {
    onOpen() {
      this.$nextTick(() => {
        this.observer.observe(this.$refs.load);
      });
    },
    onClose() {
      this.observer.disconnect();
    },
    setPage(page = 1) {
      this.pagination.page = page;
    },
  },
  mounted() {
    this.observer = new IntersectionObserver(
      async ([{ isIntersecting, target }]) => {
        const { page, page_size, count } = this.pagination;
        if (!isIntersecting) {
          return;
        }
        this.target = target;
        if (count > page * page_size) {
          this.$emit("fetch", {
            page: page + 1,
            page_size,
          });
          this.pagination.page += 1;
        } else {
          this.load = false;
        }
      }
    );

    const { page_size } = this.pagination;

    this.$emit("fetch", {
      page: 1,
      page_size,
    });

    this.pagination.page += 1;
  },
};
</script>

<style scoped>
.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>